import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../common2/Breadcrumbs";
import WebForms from "../webForms/WebForms";
// import WebForms from "./WebForms";

function TicketAdditionalAddWebForm() {
    const param = useParams();
    const submitHandler = () => {}
    return (
        <>
            <Box>
                <Breadcrumbs
                    data={[
                        {
                            title:'System Management ',
                            path:'/adminPanel' 
                        },
                        {
                            title: "Ticket Additional Field",
                            path: "/TicketAdditionalField",
                        },
                        {
                            title: `${param?.id ? "Edit" : "Add"} Ticket Additional Field`,
                            path: `${param.id ? "/TicketAdditionalAddWebForm/" + param.id : "/TicketAdditionalAddWebForm"}`
                        }
                    ]
                    }
                />
                <WebForms type = "TicketAdditionalField" />
            </Box>
        </>
    )
}

export default TicketAdditionalAddWebForm